import React, { useEffect } from 'react';

export default function SeoMeta({ title, metaTitle, metaDescription, slug, isHome = false }) {
  const pageTitle = metaTitle || `${title} — Kanmanfryse.dk`;
  const url = isHome ? "https://www.kanmanfryse.dk/" : `https://www.kanmanfryse.dk/${slug}`;

  useEffect(() => {
    // Opdater document.title
    document.title = pageTitle;

    // Opdater eller tilføj meta description
    let descTag = document.querySelector('meta[name="description"]');
    if (!descTag) {
      descTag = document.createElement('meta');
      descTag.name = 'description';
      document.head.appendChild(descTag);
    }
    descTag.content = metaDescription;

    // Opdater eller tilføj canonical link
    let canonicalTag = document.querySelector('link[rel="canonical"]');
    if (!canonicalTag) {
      canonicalTag = document.createElement('link');
      canonicalTag.rel = 'canonical';
      document.head.appendChild(canonicalTag);
    }
    canonicalTag.href = url;

    // Scroll to top on route change
    window.scrollTo(0, 0);
  }, [pageTitle, metaDescription, url]);

  // JSON-LD schema
  const articleJsonLd = !isHome ? {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": title,
    "inLanguage": "da",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": url
    },
    "datePublished": "2026-10-01",
    "dateModified": "2026-10-01",
    "publisher": {
      "@type": "Organization",
      "name": "Kanmanfryse.dk",
      "url": "https://www.kanmanfryse.dk"
    }
  } : {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Kanmanfryse.dk",
    "url": "https://www.kanmanfryse.dk",
    "description": "Uafhængig dansk opslagsguide til frysning, optøning og holdbarhed af mad.",
    "inLanguage": "da"
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(articleJsonLd) }}
    />
  );
}
